/**
 * Map server channel class names to dispatch domains.
 * Add entries when you add Action Cable channels on the server.
 */
const CHANNEL_TO_DOMAIN = {
  AlertChannel: 'alert',
};

function channelToDomain(channel) {
  if (CHANNEL_TO_DOMAIN[channel]) return CHANNEL_TO_DOMAIN[channel];
  if (!channel || typeof channel !== 'string') return 'unknown';
  return channel.replace(/Channel$/, '').toLowerCase();
}

/**
 * Turn an Action Cable broadcast envelope into a stable app event.
 * @returns {{ domain: string, type: string, payload: unknown, meta: object } | null}
 */
export function normalizeCableBroadcast(identifierString, messageBody) {
  let channel;
  try {
    const parsed = JSON.parse(identifierString);
    channel = parsed.channel;
  } catch {
    return null;
  }

  const domain = channelToDomain(channel);
  let type = 'message';
  let payload = messageBody;

  if (messageBody && typeof messageBody === 'object') {
    if (typeof messageBody.type === 'string') type = messageBody.type;
    if ('payload' in messageBody) payload = messageBody.payload;
  }

  return {
    domain,
    type,
    payload,
    meta: {
      channel,
      identifier: identifierString,
      rawMessage: messageBody,
    },
  };
}
